<template>
  <F360Accordion title="Termos de uso">
    <div class="termos-condicoes">
      <div class="termos-condicoes__items">
        <div
          v-for="item in termos"
          :key="item.icon"
          class="termos-condicoes__item"
        >
          <MaterialIcon :icon="item.icon" class="termos-condicoes__icon" />
          <p
            class="termos-condicoes__text"
            v-html="sanitizeHtml(item.text)"
          />
        </div>
      </div>

      <div class="termos-condicoes__aceite">
        <F360Checkbox :model-value="true" disabled />
        <span>
          Os
          <a class="termos-condicoes__link" @click="handleTermos"
            >termos de uso</a
          >
          do Agente de IA da F360 foram aceitos.
        </span>
      </div>
    </div>
  </F360Accordion>
</template>

<script setup lang="ts">
import F360Accordion from "@/ui/components/Accordions/F360Accordion.vue";
import F360Checkbox from "@/ui/components/Checkboxs/Checkbox/F360Checkbox.vue";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import { sanitizeHtml } from "@/core/common/sanitizeHtml";

const termos = [
  {
    icon: "check_circle",
    text: "<b>A precisão dos insights</b> depende da <b>qualidade</b> das informações registradas no sistema."
  },
  {
    icon: "search_insights",
    text: "<b>Os insights são gerados por Inteligência Artificial e têm caráter orientativo</b>, não substituindo análises profissionais."
  },
  {
    icon: "verified_user",
    text: "Os dados coletados geram os insights e ajudam a melhorar o produto, sempre de <b>forma anônima</b>."
  }
];

const handleTermos = () => {
  window.open("https://f360.com.br/politica-privacidade/", "_blank");
};
</script>

<style scoped lang="scss">
.termos-condicoes {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px 16px;

  &__items {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid _map.get($map: $neutro, $key: 100);
    border-radius: 6px;
    background-color: _map.get($map: $neutro, $key: 0);
  }

  &__icon {
    flex: 0 0 auto;
    margin-top: 1px;
    font-size: 18px;
    color: _map.get($map: $azulPrincipal, $key: 700);
  }

  &__text {
    margin: 0;
    color: _map.get($map: $neutro, $key: 800);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
  }

  &__aceite {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: _map.get($map: $neutro, $key: 600);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 12px;
    line-height: 18px;
  }

  &__link {
    color: _map.get($map: $azulPrincipal, $key: 600);
    text-decoration: underline;
  }
}
</style>
